export default __webpack_public_path__ + "static/media/EAST2560.34I-34699_-19297_0.7a690ec4.jpg";